// extracted by mini-css-extract-plugin
export var arrow = "CollectionFilter-module--arrow--eb03e";
export var arrowNo = "CollectionFilter-module--arrow_no--7c8fb";
export var arrowYes = "CollectionFilter-module--arrow_yes--fe84c";
export var dropdownContainer = "CollectionFilter-module--dropdownContainer--a2dae";
export var filterButtons = "CollectionFilter-module--filterButtons--f5bb4";
export var filterColTitle = "CollectionFilter-module--filterColTitle--a184e";
export var flex = "CollectionFilter-module--flex--4c720";
export var flex1 = "CollectionFilter-module--flex_1--b489b";
export var flexCenter = "CollectionFilter-module--flex_center--39490";
export var flexCenterCol = "CollectionFilter-module--flex_center_col--58d2b";
export var flexCol = "CollectionFilter-module--flex_col--e13de";
export var flexFixCenterCol = "CollectionFilter-module--flex_fix_center_col--a0df0";
export var flexFixedCenterCol = "CollectionFilter-module--flex_fixed_center_col--ddc26";
export var noBorder = "CollectionFilter-module--noBorder--3d68a";
export var rotating = "CollectionFilter-module--rotating--10c72";
export var searchFilterColumn = "CollectionFilter-module--searchFilterColumn--a28d7";
export var sortResultsDropdownContainer = "CollectionFilter-module--sortResultsDropdownContainer--290ff";